

import React, { useState, useEffect } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import ModificationProductionProduct from './ModificationProductionProduct';
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import Loader from "../loader/Loader";
import { formatDate } from "../../utils/formatDate"
const IndividualProductionDetailsModal = ({ show, handleClose, individualId }) => {
  const [modificationProduction, setModificationProduction] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modification, setModification] = useState([]);
  const [poplan, setPoplan] = useState([])
  const [stockplan, setStockplan] = useState(null)
  const IndividualProduction = async () => {
    const token = getAuthToken();
    if (!token) return;
    setLoading(true);
    try {
      const response = await axios.get(
        `${config.API}/manager/modificationtoproductionplanproduct/${individualId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response?.data?.success) {
        setModification(response?.data?.plans || []);
        setStockplan(response?.data?.stock || [])
        setPoplan(response?.data?.poplan || [])
      } else {
        setModification([]);
      }
    } catch (err) {
      console.error("Error fetching data:", err.message);
      setModification([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (individualId) {
      IndividualProduction();
    }
  }, [individualId]);
  const product = modification[0]?.product;
  return (
    <>
      <Modal show={show} onHide={handleClose} size="xl" centered className="font_family">
        <Modal.Header closeButton>
          <h5 className="fw-bold mb-4">Individual Product Production Details</h5>
        </Modal.Header>
        {
          loading ? (
            <Loader />
          ) : (
            <Modal.Body>
              <div className="border rounded p-3 mb-4 bg-light">
                <h6>
                  <strong>Product Details</strong>
                </h6>
                <div className="row">
                  <div className="col-md-3 col-sm-6 mb-2">
                    <p><strong>Product Name:</strong>{product?.name || "NA"}</p>
                  </div>
                  <div className="col-md-3 col-sm-6 mb-2">
                    <p><strong>Product ID:</strong> {product?.product_code || "NA"}</p>
                  </div>
                  <div className="col-md-3 col-sm-6 mb-2">
                    <p><strong>Product Category:</strong> {product?.category || "Rubber"}</p>
                  </div>
                  <div className="col-md-3 col-sm-6 mb-2">
                    <p><strong>Product Stock:</strong> {stockplan || "NA"}</p>
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <h6>
                  <strong>Production Plan for Product</strong>
                </h6>
                <div className="table-responsive">
                  <Table hover size="sm" className="align-middle">
                    <thead className="table-light">
                      <tr>
                        <th>MONTH</th>
                        <th>QTY PLANNED</th>
                        <th>QTY PRODUCED</th>
                        <th>QTY PENDING</th>
                        <th>STATUS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {modification.map(item => {
                        return (
                          <tr key={item.id}>
                            <td>{item.month || "NA"}</td>
                            <td>
                              {item?.qty_produced != null || item?.qty_pending != null
                                ? Number(item?.qty_produced || 0) + Number(item?.qty_pending || 0)
                                : "NA"}
                            </td>
                            <td>{item?.qty_produced || "NA"}</td>
                            <td>{item?.qty_pending || "NA"}</td>
                            <td>
                              { Number(item.qty_pending) === 0
                                  ? "Completed"
                                  : item?.purchase_order?.delivery_status || "NA"
                              }
                            </td>
                          </tr>
                        );
                      })}

                    </tbody>
                  </Table>
                </div>
              </div>
              <div>
                <h6>
                  <strong>POs for Product</strong>
                </h6>
                <div className="table-responsive">
                  <Table hover size="sm" className="align-middle">
                    <thead className="table-light">
                      <tr>
                        <th>PO ID</th>
                        <th>QTY REQUIRED</th>
                        <th>QTY PRODUCED</th>
                        <th>QTY PENDING</th>
                        <th>INSPECTION DATE</th>
                      </tr>
                    </thead>
                    <tbody>
                      {poplan.map(item => {
                        const qty_pending =
                          Number(item?.order_quantity ?? 0) -
                          Number(item?.produced_quantity ?? 0)
                        return (
                          <tr key={item.id}>
                            <td>{item?.po_number}</td>
                            <td>{item?.order_quantity}</td>
                            <td>{item.produced_quantity}</td>
                            <td>{qty_pending}</td>
                            <td>{formatDate(item?.inspection_date)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Modal.Body>
          )
        }
        <Modal.Footer>
          <Button variant="dark" onClick={() => setModificationProduction(true)}>
            Modify Production Plan
          </Button>
        </Modal.Footer>
      </Modal>

      {/* modificationProductionProduct */}
      <ModificationProductionProduct
        show={modificationProduction}
        modificationId={individualId}
        handleClose={() => setModificationProduction(false)}
        refreshParent={IndividualProduction}
      />
    </>
  );
};

export default IndividualProductionDetailsModal;
